import { createStore } from 'vuex'
// 引入持久化
import createPersistedState from 'vuex-persistedstate';

export default createStore({
    // 存储数据
    state: {
        spotCheckInfo:{},
        popObj: {},
        followObj: {},
        caseData: {
            data1: 0,
            data2: 0,
            data3: 0,
            data4: 0,
            data5: 0,
            data6: 0,
            data7: 0,
            data1_1: 0,
            data1_2: 0,
            data1_3: 0,
            data1_4: 0,
            data1_5: 0,
            current_handle_num: 0,
            urgent_total_num: 0,
            urgent_warning_num: 0,
            cause_num_total: 0,
            suspend_total_num:0,
            windup_audit_total: 0,
            new_data1: 0,
            new_data2: 0,
            new_data3: 0,
            old_data1: 0,
            old_data2: 0,
            old_data3: 0,
        },
        caseInfo: {
            value1: "",
            value2: "",
            value3: "",
            value4: "",
            value5: "",
            value6: "",
            value7: "",
            value8: "",
        },
        navbool: true,
        userInfo: {},
        lineInfo: {},
        testnum: 0,
        searchInfo: {},
        searchPage: 1,
        seaInfo: {},
        orderInfo: {},
        routerPath: "",
        routerBool: {},
        listData: {
            data1: 0,
            data2: 0,
            data3: 0,
            data4: 0
        },
        seaData: {
            data1: 0,
            data2: 0,
            data3: 0
        },
        orderData: {
            data1: 0,
            data2: 0,
            data3: 0,
            data4: 0,
            data5: 0,
        },
        checkData: {
            data1: 0,
            data2: 0,
            data3: 0,
        },
        checkInfo: {}
    },
    // 存储复杂数据
    getters: {
    },
    // 存储函数方法
    mutations: {
        setSpotCheckInfo(state,e){
            state.spotCheckInfo=e
        },
        setPopObj (state, popObj) {
            state.popObj = popObj
        },
        setFollowObj (state, followObj) {
            state.followObj = followObj
        },
        setCaseData (state, caseData) {
            console.log(state.caseData,"00000000000")
            state.caseData.data1 = caseData.data1
            state.caseData.data2 = caseData.data2
            state.caseData.data3 = caseData.data3
            state.caseData.data4 = caseData.data4
            state.caseData.data5 = caseData.data5
            state.caseData.data6 = caseData.data6
            state.caseData.data7 = caseData.data7
            state.caseData.data1_1 = caseData.data1_1
            state.caseData.data1_2 = caseData.data1_2
            state.caseData.data1_3 = caseData.data1_3
            state.caseData.data1_4 = caseData.data1_4
            state.caseData.data1_5 = caseData.data1_5
            state.caseData.current_handle_num = caseData.current_handle_num
            state.caseData.urgent_total_num = caseData.urgent_total_num
            state.caseData.urgent_warning_num = caseData.urgent_warning_num
            state.caseData.new_data1 = caseData.new_data1
            state.caseData.new_data2 = caseData.new_data2
            state.caseData.new_data3 = caseData.new_data3
            state.caseData.old_data1 = caseData.old_data1
            state.caseData.old_data2 = caseData.old_data2
            state.caseData.old_data3 = caseData.old_data3
            state.caseData.overdue_num = caseData.overdue_num
            state.caseData.not_overdue_num = caseData.not_overdue_num
            state.caseData.cause_num_total = caseData.cause_num_total
            state.caseData.suspend_total_num = caseData.suspend_total_num
            state.caseData.windup_audit_in = caseData.windup_audit_in
            state.caseData.windup_audit_reject = caseData.windup_audit_reject
            state.caseData.windup_audit_total = caseData.windup_audit_total
            state.caseData.suspend_customer_num=caseData.suspend_customer_num
            state.caseData.suspend_legal_num=caseData.suspend_legal_num
            state.caseData.suspend_auto_num=caseData.suspend_auto_num
        },
        setCaseInfo (state, caseInfo) {
            state.caseInfo.value1 = caseInfo.value1
            state.caseInfo.value2 = caseInfo.value2
            state.caseInfo.value3 = caseInfo.value3
            state.caseInfo.value4 = caseInfo.value4
            state.caseInfo.value5 = caseInfo.value5
            state.caseInfo.value6 = caseInfo.value6
            state.caseInfo.value7 = caseInfo.value7
            state.caseInfo.value8 = caseInfo.value8
        },
        changeNavbool (state, navbool) {
            state.navbool = navbool
        },
        // 存储用户信息
        loginSuccess (state, userInfo) {
            state.userInfo = userInfo
        },
        //退出登录清除用户信息
        loginOut (state) {
            state.userInfo = {}
        },
        // 存储用户线索
        setUserId (state, lineInfo) {
            state.lineInfo = lineInfo
        },
        // 搜索调用
        searcher (state, searchInfo) {
            state.searchInfo = searchInfo
        },
        // 重置调用
        reseter (state) {
            state.searchInfo = {}
        },
        // 公海搜索调用
        seaSearch (state, seaInfo) {
            state.seaInfo = seaInfo
        },
        // 公海重置调用
        seaReset (state) {
            state.seaInfo = {}
        },
        // 路由跳转打印
        setRouter (state, routerPath) {
            state.routerPath = routerPath
        },
        // 路由布尔值
        setRouterBool (state, routerBool) {
            state.routerBool = routerBool
        },
        // 存储线索列表导航数据
        setlistData (state, listData) {
            state.listData.data1 = listData.data1
            state.listData.data2 = listData.data2
            state.listData.data3 = listData.data3
            state.listData.data4 = listData.data4
        },
        // 存储线索公海导航数据
        setseaData (state, seaData) {
            state.seaData.data1 = seaData.data1
            state.seaData.data2 = seaData.data2
            state.seaData.data3 = seaData.data3
            state.seaData.data4 = seaData.data4
        },
        // 存储页面page
        setSearchPage (state, page) {
            state.searchPage = page
        },
        // 订单搜索调用
        orderSearch (state, orderInfo) {
            state.orderInfo = orderInfo
        },
        // 订单重置调用
        orderReset (state) {
            state.orderInfo = {}
        },
        // 存储财务管理导航数据
        setOrderData (state, orderData) {
            state.orderData.data1 = orderData.data1
            state.orderData.data2 = orderData.data2
            state.orderData.data3 = orderData.data3
            state.orderData.data4 = orderData.data4
            state.orderData.data5 = orderData.data5
        },
        // 存储补录审核导航数据
        setCheckData (state, checkData) {
            state.checkData.data1 = checkData.data1
            state.checkData.data2 = checkData.data2
            state.checkData.data3 = checkData.data3
        },
        checkSearch (state, checkInfo) {
            state.checkInfo = checkInfo
        },
        checkReset (state) {
            state.checkInfo = {}
        }
    },
    // 异步调用函数
    actions: {
    },
    // 模块
    modules: {
    },
    //持久化数据
    plugins: [
        createPersistedState({
            // 存储方式：localStorage、sessionStorage、cookies
            storage: window.sessionStorage,
            // 存储的 key 的key值
            key: "store",
            render (state) {
                // 要存储的数据：本项目采用es6扩展运算符的方式存储了state中所有的数据
                return { ...state };
            }
        })
    ]
})
